import Header from '@src/components/Header';
import Footer from '@src/components/Footer';

export default function BasePage({ children }) {
  return (
    <>
      <Header />
      {children}
      <Footer />
    </>
  );
}
